import FieldConfig from "../../../../proto/field-config"
import FieldDateRange from "../../../../generic/datetime/date-range/date-range"
import {convertToMomentRangeFromValue} from "../../../../../gd/convert/moment-range"
import ItemModelV2 from "../../../../../model2/item2/item-model"
import TasksViewManager from "../../../../../gd-modules/tasks-view/core/manager"
import Task from "../../../../../model2/task/task"
import {ViewType} from "../../../../../gd/const/views/view-type"
import GanttManager from "../../../../../gd-modules/gantt-chart/manager/manager"
import FieldProto_updateView from "../../../../proto/render/table/function/update-view"

export default class FieldTaskStartEnd extends FieldDateRange {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel  = "Start / End";
        this.label      = "Start / End";

        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange
    }

    getViewValue(model: any): any {
        if (model.startDate && model.endDate) {
            return convertToMomentRangeFromValue({
                start   : model.startDate,
                end     : model.endDate
            })
        }
        return null
    }

    sortValue(value: any, model?: any) {
        if (!model.startDate || !model.endDate) return ''

        return "{0} - {1}".f(model.startDate.format('X'), model.endDate.format('X'))
    }

    get requiredBackendFields() {
        return ['startDate','endDate']
    }

    canEdit(model:Task):boolean {
        return model.acl.canChangeStartDate
    }


    // Table

    tableCellOnValueChange = async (item: ItemModelV2, value: MomentRange|null, manager: TasksViewManager|GanttManager) => {

        switch (manager.module) {
            case ViewType.PROJECT_GANTT:
            case ViewType.PORTFOLIO_GANTT:
            case ViewType.CUSTOM_VIEW_GANTT:

                const newStartDate  = value ? value.start : null
                const newEndDate    = value ? value.end : null

                const ganttManager = manager as GanttManager
                ganttManager.setStartEnd(item.id, newStartDate, newEndDate)

                break

            default:
                if (!value) {
                    // jsut start is enough
                    item.task.updateStartDate(null)
                } else {
                    item.task.updateStartDate(value.start)
                    item.task.updateEndDate(value.end)
                }

                item.task.save()

                item.updateLastUpdateTime() // otherwise it wont re-render

                FieldProto_updateView(manager as TasksViewManager, this)
                break
        }

    }
}
